import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import AuthContextProvider from './shared/src/components/molecules/auth-context-provider/authContextProvider';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient()

root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<HashRouter>
				<AuthContextProvider>
					<App />
				</AuthContextProvider>
			</HashRouter>
		</QueryClientProvider>
	</React.StrictMode>
);
serviceWorkerRegistration.unregister();
reportWebVitals();
